import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';

interface PageLayoutProps {
  children: React.ReactNode;
  showBreadcrumb?: boolean;
}

export default function PageLayout({ children, showBreadcrumb = true }: PageLayoutProps) {
  return (
    <div className="min-h-screen bg-background-50">
      <ScrollToTop />
      <Navbar />
      {showBreadcrumb && <Breadcrumb />}
      <main>{children}</main>
      <Footer />
    </div>
  );
}